<template>
<div :style="{'min-height':height+'px'}">
  <div class="coupon">
    <div class="coupon-item coupon-item-expired" v-for="item,index in coupon_list" :key="index">
      <div class="coupon-item-top">
        <p class="p1">￥<span>{{item.amount_value}}</span> 优惠券</p>
        <p class="p2">过期时间：{{item.effective_time}}</p>
      </div>
      <div class="coupon-item-content">
        <div v-html="item.summary"></div>
        <Button>已过期</Button>
      </div>
    </div>
  </div>
  <div class="page clear" v-if="total > 10">
    <Page
      :total="total"
      :page-size="10"
      class="page_list"
      show-total
      show-elevator
      :current="page"
      @on-change="changePage"
    />
  </div>
  <Nothing v-if="total == 0">
    <p>没有已过期优惠券</p>
  </Nothing>
</div>
</template>
<script>
import Nothing from '@/components/Nothing2'
import {
  couponList
} from '../../../service'
export default {
  components: {
    Nothing
  },
  data() {
    return {
      height: 0,
      page: 1,
      total: 0,
      coupon_list: []
    }
  },
  methods: {
    async couponList() {
      let res = await couponList({
        user_key: this.$store.state.user_key,
        page: this.page,
        status: '1',
        is_effective: '0',
        order_type: '1'
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'coupon_list', res.res)
        this.$set(this.$data, 'total', res.count)
        this.$emit('num', res.count)
      } else {
        this.$Message.error(res.message)
      }
    },
  },
  changePage(page) {
    this.page = page
    this.paidReport()
  },
  created() {
    this.couponList()
  },
  mounted() {
    this.height = document.documentElement.clientHeight - 202
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/coupon.stylus'
</style>
